import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Button, CircularProgress } from "@mui/material";
import { SuccessCheckIcon } from "../Core/Icons/SuccessCheckIcon";

const CheckUpSuccessModal = ({ open, onClick }) => {
  // const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={(theme) => ({
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "768px",
          height: "268px",
          bgcolor: "background.paper",
          borderRadius: "32px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          [theme.breakpoints.down("md")]: {
            margin: "0 16px",
            padding: "0 24px",
            minWidth: "500px",
            width: "auto",
            // height: "198px",
          },
          [theme.breakpoints.down("sm")]: {
            margin: "0 16px",
            padding: "0 24px",
            minWidth: "300px",
            width: "auto",
            // height: "198px",
          },
        })}
      >
        <Box sx={{ display: "flex", marginBottom: "16px" }}>
          <SuccessCheckIcon width="62px" height="62px" />
        </Box>
        <Typography
          sx={(theme) => ({
            fontSize: "24px",
            lineHeight: "32px",
            fontWeight: "600",
            color: "#1C1C1E",
            marginBottom: "8px",
            [theme.breakpoints.down("md")]: {
              fontSize: "18px",
              lineHeight: "22px",
            },
          })}
        >
          Проверка пройдена успешно
        </Typography>
        <Typography
          sx={(theme) => ({
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: "400",
            color: "#676971",
            marginBottom: "16px",
            [theme.breakpoints.down("md")]: {
              fontSize: "18px",
              lineHeight: "22px",
            },
          })}
        >
          Прикрепите документы подтверждающие доход.
        </Typography>
        <Button
          sx={(theme) => ({
            padding: "13px 24px",
            backgroundColor: "#27AE60",
            color: "#FFF",
            fontSize: "16px",
            fontWeight: "500",
            lineHeight: "24px",

            borderRadius: "10px",
            ":hover": {
              background: "#27AE60",
              color: "#FFF",
            },
            [theme.breakpoints.down("sm")]: {
              //   marginTop: '',
              // width: "100%",
            },
          })}
          onClick={onClick}
        >
          Прикрепить документы
        </Button>
      </Box>
    </Modal>
  );
};

export default CheckUpSuccessModal;
